import styles from "./AdmissionProcess.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoAddCircleOutline } from "react-icons/io5";

const data = [
  {
    _id: "1",
    title: "Admission 1",
    status: "Live",
    dueDate: 0,
    totalStudents: 0,
    actions: ["Edit", "Delete"],
  },
  {
    _id: "2",
    title: "Admission 2",
    status: "Live",
    dueDate: 0,
    totalStudents: 0,
    actions: ["Edit", "Delete"],
  },
  {
    _id: "3",
    title: "Reference 1",
    status: "Live",
    dueDate: 0,
    totalStudents: 0,
    actions: ["Edit", "Delete"],
  },
  {
    _id: "4",
    title: "Reference 2",
    status: "Live",
    dueDate: 0,
    totalStudents: 0,
    actions: ["Edit", "Delete"],
  },
];
  

function AdmissionProcess() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal("newProcess"));
  };
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        title: (
          <div className={styles.titleCell}>
            <RiFileTextLine className={styles.fileIcon} color="#4F46E5" />
            {item.title}
          </div>
        ),
        status: (
          <div className={styles.status}>
            <span className={styles.greenDot}></span>
            Live
          </div>
        ),
        dueDate: item.dueDate,
        totalStudents: item.totalStudents,
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => console.log(`Selected ${opt} for ${item.title}`)}
          />
        ),
      };
    });
  };
  

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Process Name", accessor: "title" },
    { title: "Status", accessor: "status" },
    { title: "Due Date", accessor: "dueDate" },
    { title: "Total Students", accessor: "totalStudents" },
    { title: "Action", accessor: "action" },
  ];
  
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}
        <div className={styles.createForm}>
          <IconAndName
            icon={<IoAddCircleOutline />}
            title="New Process"
            bgColor="Primary_Color"
            onClick={handlecreateform}
          />
        </div>

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search by name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <Dropdown
              label="All Status"
              options={["Live", "Inactive", "Draft"]}
              bgColor="rgba(240, 240, 240, 1)"
              borderRadius="10px"
            />
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default AdmissionProcess;
